module.exports = __webpack_public_path__ + "img/call-me-emperor.b60a2ea.jpg";